<template>
  <div class="insight-event">
    <div
      :class="['insight-event-home team', {
        win: Number(event.homeScoreWholeMatch) > Number(event.awayScoreWholeMatch)
      }]"
    >
      {{ event.homeCompetitor }}
    </div>
    <div
      :class="['insight-event-away team', {
        win: Number(event.homeScoreWholeMatch) < Number(event.awayScoreWholeMatch)
      }]"
    >
      {{ event.awayCompetitor }}
    </div>
  </div>
</template>
  
  <script>
export default {
  name: 'InsightEvent',
  props: {
    event: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
  
  <style lang="scss">
  @use "@ms/styles/_mixin.scss" as mixin;

  .insight-event {
    flex: 1;
    padding: 8px 0;
    margin-right: 6px;
    color: #fff;
    font-size: 12px;
    line-height: 16px;
    text-align: left;

    @include mixin.ellipsis();

    &-home {
      margin-bottom: 2px;
    }

    .team {
      width: 100%;
      height: 16px;

      @include mixin.ellipsis();
    }

    .win {
      font-weight: 800;
    }
  }
  </style>